const isEmpty = (value) => !value;
const isLengthExceed = (value, desiredLength) => value.length > desiredLength;
const isLengthNotEqual = (value, desiredLength) => value.length !== desiredLength;
/**
 * Return error message key to calling function where it should map the error message.
 */
const validationRules = {
    routingNumber: ({ value }) => {
        if (isEmpty(value)) {
            return 'routingNumberRequired';
        }
        if (isLengthNotEqual(value, 9)) {
            return 'routingNumberMust9Digits';
        }
        return '';
    },
    accountNumber: ({ value, desiredLength }) => {
        if (isEmpty(value)) {
            return 'accountNumberRequired';
        }
        if (value.length < 5 || isLengthExceed(value, desiredLength)) {
            return 'accountNumberLengthInvalid';
        }
        return '';
    },
    nickname: ({ value, isRequired }) => {
        if (isRequired && isEmpty(value.trim())) {
            return 'nicknameRequired';
        }
        if (!isEmpty(value.trim()) && !/^[a-zA-Z0-9 ]+$/i.test(value)) {
            return 'invalidNickname';
        }
        return '';
    }
};
const validate = (fieldName, value, desiredLength, isRequired) => validationRules[fieldName]({
    value,
    desiredLength,
    isRequired
});
export default validate;
